import { call, put, takeEvery } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import * as SettingActions from './setting.actions';
import SettingAPI from './setting.api';
import { SettingActionTypes } from './setting.model';


export function* handleUpdateSetting(action) {
  try {
    const response = yield call(SettingAPI.UpdateSetting, action.payload);
    yield put(SettingActions.updateSettingSuccess(response));
    Swal.fire({
      icon: "success",
      title: "Settings Updated",
      text: "Settings Updated Successfully"
    })
  } catch (e) {
    yield put(SettingActions.updateSettingFailure(e));
  }
}

export function* handleSettings() {
  try {
    const response = yield call(SettingAPI.GetSetting);
    yield put(SettingActions.fetchSettingsSuccess(response));
  } catch (e) {
    yield put(SettingActions.fetchSettingsFailure(e));
  }
}

export function* SettingSaga() {
  yield takeEvery(SettingActionTypes.UPDATE_SETTING_REQUEST, handleUpdateSetting);
  yield takeEvery(SettingActionTypes.FETCH_SETTINGS_REQUEST, handleSettings);
}

